import { render, staticRenderFns } from "./TabIndicator.vue?vue&type=template&id=44a0e745&scoped=true"
import script from "./TabIndicator.vue?vue&type=script&lang=js"
export * from "./TabIndicator.vue?vue&type=script&lang=js"
import style0 from "./TabIndicator.vue?vue&type=style&index=0&id=44a0e745&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44a0e745",
  null
  
)

export default component.exports